import React from "react";
import SideMenuComponent from "./SideMenu";

const SideMenu = ({ isFullWidth }) => (
  <SideMenuComponent isFullWidth={isFullWidth} />
);

export default SideMenu;
